import { Component, Input, ComponentRef, ComponentFactoryResolver, ViewContainerRef, ViewChild } from '@angular/core';
import { NavController } from '@ionic/angular';
import { Store } from '@ngrx/store';
import * as navigationActions from '../../store/session/actions/navigation.actions';
import { State } from '../../store/state.reducer';

@Component({
  selector: 'cl-modal',
  styleUrls: ['modal.component.scss'],
  templateUrl: 'modal.component.html'
})
export class ModalComponent {
  modal;
  componentRef: ComponentRef<any>;

  @ViewChild('componentContainer', {static: true, read: ViewContainerRef}) componentContainer: ViewContainerRef;

  @Input() header: string;
  @Input() headline: string;
  @Input() showBackButton?: boolean = true;
  @Input() content: string;
  @Input() icon: string;
  @Input() actionText: string;
  @Input() actionCb;

  @Input()
  set embedComponent(value: any) {
    this.componentRef = this.componentContainer.createComponent(this.resolver.resolveComponentFactory<any>(value));
    this._setComponentProperties();
  }

  _componentProps;
  @Input()
  set componentProps(value: any) {
    this._componentProps = value;
    this._setComponentProperties();
  }

  constructor(
    private resolver: ComponentFactoryResolver,
    public navCtrl: NavController,
    public store: Store<State>
  ) { }

  onClose() {
    this.store.dispatch(new navigationActions.CloseModal({modalId: this.modal.id, role: 'close-btn'}));
  }

  private _setComponentProperties() {
    if (this._componentProps && this.componentRef) {
      Object.keys(this._componentProps)
        .forEach((key) => {
          this.componentRef.instance[key] = this._componentProps[key];
        });
    }
  }
}
